import {
  IdentityProviders,
  SignInPage,
  SignInProviderConfig,
} from '@backstage/core-components';
import {
  configApiRef,
  microsoftAuthApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import {
  SignInPageBlueprint,
  SignInPageProps,
} from '@backstage/plugin-app-react';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';

// Named component so hooks satisfy react-hooks/rules-of-hooks
const SignInPageContent = (props: SignInPageProps) => {
  const configApi = useApi(configApiRef);
  const signInProvider =
    configApi.getOptionalString('signInPage.provider') ?? 'microsoft';

  if (signInProvider === 'guest') {
    return <SignInPage {...props} auto providers={['guest']} />;
  }

  const microsoftAuthProvider: SignInProviderConfig = {
    id: 'microsoft-auth-provider',
    title: 'Azure AD',
    message: 'Sign in using Azure',
    apiRef: microsoftAuthApiRef,
  };
  const providers: IdentityProviders = [microsoftAuthProvider];

  return <SignInPage {...props} providers={providers} />;
};

export const signInPage: ExtensionDefinition = SignInPageBlueprint.make({
  params: {
    loader: async () => SignInPageContent,
  },
});
